import styled from "styled-components"
import { fontRegular, fontBold } from "../../../utils/fontStyles"
import { textBlueColor } from "../../../theme"

const BannerWrapper = styled.div`
  background-color: #EEF7FF;
  border: ${props => props.border};
  overflow: hidden;
  ${({ theme }) => theme.se`
  padding-top: 2em;
    padding-bottom: 2em;
    `}
  ${({ theme }) => theme.tablet`
        padding-top: 6em;
    padding-bottom: 5em;
    `}
  ${({ theme }) => theme.desktop`
 padding-top: 5em;
    padding-bottom: 4em;
    `}
  ${({ theme }) => theme.largeDesktop`
padding-top: 6em;
    padding-bottom: 5em;
        `}
        ${({ theme }) => theme.massiveDesktop`
padding-top: 8em;
    padding-bottom: 8em;
        `}
    

  > div.container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    ${({ theme }) => theme.se`
        flex-direction: column-reverse;
        max-width: 300px;
      `}
      ${({ theme }) => theme.phone`
        max-width: 350px;
  `}
  ${({ theme }) => theme.phablet`
        max-width: 555px;
  `}
    ${({ theme }) => theme.tablet`
        flex-direction: row;
      max-width: 650px;
    `}
    ${({ theme }) => theme.desktop`
        max-width: 860px;
      `}
    ${({ theme }) => theme.largeDesktop`
        max-width:1000px;
      `}
      ${({ theme }) => theme.massiveDesktop`
      max-width:1173px;
      `}
  }
`

export const BannerContent = styled.div`
      width: 100%;
  ${({ theme }) => theme.se`
      max-width: 260px;
    `}
    ${({ theme }) => theme.phone`
  max-width: 300px;
  `}
  ${({ theme }) => theme.phablet`
   max-width: 541px;
  `}
  ${({ theme }) => theme.tablet`
    max-width: 390px;
  `}
  ${({ theme }) => theme.desktop`
      max-width: 541px;
    `}
  ${({ theme }) => theme.largeDesktop`
      max-width: 541px;
    `}
    ${({ theme }) => theme.massiveDesktop`
      max-width: 593px;
    `}
`

export const BannerHeading = styled.div`
  color: ${textBlueColor};
  font-family: 'Muli', sans-serif;
  font-weight: 900;
    width: 100%;
  ${({ theme }) => theme.se`
  text-align: center;
    margin-left: auto;
    margin-right: auto;
  font-size: 13px;
  letter-spacing: 0.61px;
  line-height: 22px;
  max-width: 260px;
  margin-bottom: 10px;
  `}
  ${({ theme }) => theme.phone`
  font-size: 15px;
  line-height: 25px;
  max-width: 300px;
  margin-bottom: 15px;
  `}
  ${({ theme }) => theme.phablet`
  text-align: center;
    margin-left: auto;
    margin-right: auto;
   font-size: 25px;
  line-height: 40px;
  max-width: 460px;
  margin-bottom: 20px;
  `}
  ${({ theme }) => theme.tablet`
  text-align: left;
    margin-left: 0px;
    margin-right: 0px;
    font-size: 20px;
  line-height: 30px;
  max-width: 370px;
  `}
  ${({ theme }) => theme.desktop`
     font-size: 26px;
  letter-spacing: 0.51px;
  line-height: 40px;
  max-width: 593px;
  margin-bottom: 15px;
  `}
  ${({ theme }) => theme.largeDesktop`
      font-size: 28px;
      letter-spacing: 0.71px;
    line-height: 50px;
    max-width: 593px;
    margin-bottom: 20px;
  `}
  ${({ theme }) => theme.massiveDesktop`
font-size: 32px;
  letter-spacing: 0.81px;
  line-height: 53px;
  max-width: 593px;
    `}
`

export const BannerText = styled.div`
  color: ${textBlueColor};
  ${fontRegular()}
  width:100%;
  ${({ theme }) => theme.se`
  text-align: center;
    margin-left: auto;
    margin-right: auto;
  max-width:260px;
  font-size: 10px;
  letter-spacing: 0.37px;
  line-height: 17px;   
  `}
    ${({ theme }) => theme.phone`
    max-width:300px;
  font-size: 12px;
  line-height: 20px;
  `}
  ${({ theme }) => theme.phablet`
  max-width:450px;
   font-size: 15px;
  letter-spacing: 0.47px;
  line-height: 26px;
  `}
  ${({ theme }) => theme.tablet`
  text-align: left;
    margin-left: 0px;
    margin-right: 0px;
  max-width:360px;
    font-size: 12px;
  line-height: 20px;
  `}
  ${({ theme }) => theme.desktop`
  max-width:450px;
     font-size: 15px;
  letter-spacing: 0.35px;
  line-height: 26px;
  `}
  ${({ theme }) => theme.largeDesktop`
  max-width:470px;
      font-size: 16px;
  letter-spacing: 0.40px;
  line-height: 28px;
  `}
  ${({ theme }) => theme.massiveDesktop`
  max-width:531px;
font-size: 18px;
  letter-spacing: 0.5px;
  line-height: 30px;
    `}
`
export const BannerImage = styled.div`
  ${({ theme }) => theme.se`
  display:none;
    `}
  ${({ theme }) => theme.phone`
  display:none;
    `}
     ${({ theme }) => theme.phablet`
    display:none;
   `}
  ${({ theme }) => theme.tablet`
  display: block;
    position: absolute;
    right: 0px;
    width: 100%;
    max-width: 350px;
    margin-top: 50px;
    `}
  ${({ theme }) => theme.desktop`
      max-width:400px;
      margin-top:35px;
    `}
    ${({ theme }) => theme.largeDesktop`
    max-width: 530px;
    margin-top: 55px;
    `}
    ${({ theme }) => theme.massiveDesktop`
    max-width: 700px;
    margin-top: 50px;
    `}
`

export const BannerImageForMobile = styled.div`
  ${({ theme }) => theme.se`
  display:block;
  position: relative;
    right: 0px;
  width: 100%;
  max-width:250px;
    `}
  ${({ theme }) => theme.phone`
      max-width:240px;
    `}
     ${({ theme }) => theme.phablet`
      max-width:270px;
   `}
  ${({ theme }) => theme.tablet`
  display:none;
    `}
  ${({ theme }) => theme.desktop`
  display:none;
    `}
    ${({ theme }) => theme.largeDesktop`
    display:none;
    `}
    ${({ theme }) => theme.massiveDesktop`
    display:none;
    `}
`

export const ButtonGroup = styled.div`
  display: flex;
${({ theme }) => theme.se`
  margin-top:10px;
  justify-content: center;
  flex-direction: column;
      > a button {
        width: 100%;
      }
    `}
  ${({ theme }) => theme.phone`
  margin-top:15px;
      > a button {
        width: 100%;
      }
    `}
     ${({ theme }) => theme.phablet`
  margin-top:10px;
     flex-direction: row;
       > button::first-child {
      margin-right: 10px;
    }
    `}
  ${({ theme }) => theme.tablet`
  justify-content: left;
     flex-direction: row;
       > button::first-child {
      margin-right: 10px;
    }
    `}
  ${({ theme }) => theme.desktop`
  margin-top:20px;
    > a {
      margin-right: 20px;
    }
    > .reusecore__button:hover:last-child {
        
     
        background-color: transparent;
        box-shadow: none;
      
    }
    `}
    ${({ theme }) => theme.largeDesktop`
  margin-top:25px;
    > a {
      margin-right: 20px;
    }
    > .reusecore__button:hover:last-child {
        
     
        background-color: transparent;
        box-shadow: none;
      
    }
    `}
    ${({ theme }) => theme.massiveDesktop`
  margin-top:35px;
    > a {
      margin-right: 20px;
    }
    > .reusecore__button:hover:last-child {
        
     
        background-color: transparent;
        box-shadow: none;
      
    }
    `}
  
  .reusecore__button , .productButtonStyle {
    border-radius: 8px;
    /* max-width: 160px; */
    ${fontBold()}
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 24px;
    text-align: center;
    margin-top: 20px;
    text-transform: none;
    ${({ theme }) => theme.se`
     font-size: 11px;
    `}
    ${({ theme }) => theme.phone`
  font-size: 12px;
  `}
  ${({ theme }) => theme.phablet`
   font-size: 11px;
  `}
  ${({ theme }) => theme.tablet`
   font-size: 11px;
  `}
  ${({ theme }) => theme.desktop`
      font-size: 13px;
    `}
  ${({ theme }) => theme.largeDesktop`
      font-size: 14px;
    `}
    ${({ theme }) => theme.massiveDesktop`
     font-size: 14px;
    `}
  }

  .productButtonStyle {
      ${({ theme }) => theme.desktop`
          margin-left: 32px;
      `}
  }
`

export default BannerWrapper
